export const COACH_VIDEO_PROJECTS_VIEW_STORAGE_KEY = "coachVideoProjects-viewMode";

export type CoachVideoProjectsView = "legacy" | "board";

export function readCoachVideoProjectsView(): CoachVideoProjectsView {
  if (typeof localStorage === "undefined") return "legacy";
  return localStorage.getItem(COACH_VIDEO_PROJECTS_VIEW_STORAGE_KEY) === "board" ? "board" : "legacy";
}

export function writeCoachVideoProjectsView(view: CoachVideoProjectsView): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(COACH_VIDEO_PROJECTS_VIEW_STORAGE_KEY, view);
}
